import React, { useState } from "react";

function UserInputField({ onSubmit }) {
	const [inputValue, setInputValue] = useState("");

	const handleChange = (e) => {
		setInputValue(e.target.value);
	};

	const handleKeyDown = (e) => {
		// Send message on Enter (but allow Shift + Enter for new lines)
		if (e.key === "Enter" && !e.shiftKey) {
			e.preventDefault(); // Prevent newline behavior
			handleSubmit(e);
		}
	};

	const handleSubmit = (e) => {
		e.preventDefault();
		if (inputValue.trim() === "") return; // Prevent empty messages
		onSubmit(inputValue);
		setInputValue(""); // Clear input field after submission
	};

	return (
		<form onSubmit={handleSubmit} className="kursvaljareuserInput">
			<textarea
				className="kursvaljareinputField"
				value={inputValue}
				onChange={handleChange}
				onKeyDown={handleKeyDown} // Detect Enter key press
				placeholder="Skriv här..."
				rows={1}
			/>
			<button className="sendIcon" type="submit">
				<img src="/images/sendArrow.svg" alt="Right Arrow" className="sendIcon" />
			</button>
		</form>
	);
}

export default UserInputField;
